const FALLBACK = '–';

// Callers pass a percentage (21 for 21%), while Intl's percent style expects the
// ratio behind it, hence the division.
export function formatPercent(
  value: number,
  locale: string,
  fractionDigits = 1,
  minimumFractionDigits = fractionDigits,
): string {
  if (!Number.isFinite(value)) return FALLBACK;
  return (value / 100).toLocaleString(locale, {
    style: 'percent',
    minimumFractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}
